module.exports = __webpack_public_path__ + "img/eye-in-welcome-2.f4c927c5.webp";